import { ROUTE } from '@lib/core/const';
import { PERMISSION } from '@lib/core/enum';
import { Uuid, Permission } from '@lib/core/type';
import { LinkSource } from '@proget-shared/ui/link';

export class UserEntraId implements LinkSource {
  constructor(
    public readonly id: Uuid,
    public readonly name: string
  ) {}

  getRouterLink(): string[] {
    return [
      '/',
      ROUTE.SETTINGS.BASE,
      ROUTE.SETTINGS.ENTRA_ID.BASE,
      ROUTE.SETTINGS.ENTRA_ID.USERS_CONFIGURATION.BASE,
      this.id,
      ROUTE.SETTINGS.ENTRA_ID.USERS_CONFIGURATION.EDIT,
    ];
  }

  getDisplayName(): string {
    return this.name;
  }

  getLinkPermission(): Permission {
    return PERMISSION.ALLOW_MANAGE_AZURE_AD_SETTINGS;
  }
}
